import { MetatagsContainer } from '@/modules/Metatags';

export const Metatags = (): JSX.Element => <MetatagsContainer />;

export default Metatags;
